export default "__VITE_ASSET__DWzoEvm0__"